import KIND_TABS from './kindTabs';
import LEAGUE_TABS from './leagueTabs';

export { KIND_TABS, LEAGUE_TABS };
